/* eslint-disable prefer-destructuring */
// eslint-disable-next-line import/prefer-default-export
export const API_BASE_URL = process.env.API_BASE_URL_PRODUCTION;
export const LOAD_BASE_URL = process.env.LOAD_BASE_URL_PRODUCTION;
export const GNB_BASE_URL = process.env.GNB_BASE_URL_PRODUCTION;
export const ENV_TYPE = process.env.PROD_ENV_TYPE;
